import React from 'react';
import { Tooltip, Button, Modal } from 'antd';
import { useSelector } from 'react-redux';
import { useInfoModalDispatch } from '../../../../contexts/InfoModalContext';
import { selectedInfoSelector } from '../../../../store/selectors';
import useDeleteInfo from '../../../../mutations/useDeleteInfo';
import styles from './InfoActions.module.scss';

const { confirm } = Modal;

const EditInfoBtn = () => {
  const toggleInfoModalVisible = useInfoModalDispatch();
  const info = useSelector(selectedInfoSelector);

  return (
    <Tooltip title="Изменить информирование" placement="topRight">
      <Button icon="edit" onClick={() => toggleInfoModalVisible(info)} />
    </Tooltip>
  );
};

const InfoActions = () => {
  const info = useSelector(selectedInfoSelector);

  const { deleteInfo } = useDeleteInfo();

  const handleDelete = () => {
    confirm({
      title: 'Удалить информирование?',
      content: <strong>{info?.title}</strong>,

      onOk: async () => await deleteInfo(info?.id),
      onCancel: () => {},
    });
  };

  return (
    <div className={styles.root}>
      <Tooltip title="Удалить информирование">
        <Button icon="close" onClick={handleDelete} />
      </Tooltip>
      <EditInfoBtn />
    </div>
  );
};

export default InfoActions;
